export default {
  'Your win': 'Your win',
  'Select skins that you want to take': 'Select skins that you want to take',
  'By price': 'By price',
  '(Autotrade will receive after 10 minutes)': '(Autotrade will receive after 10 minutes)',
  ACCEPT: 'ACCEPT',
  'SELECT ALL': 'SELECT ALL',
};
